import { Injectable } from '@angular/core';
import { SmartSmsRequestRecipientScheduledMessagesDetail } from '../api/models/smart-sms-request-recipient-scheduled-messages-detail';

@Injectable({
  providedIn: 'root'
})
export class SendSmartDetailsByDeliveryService {
  
  constructor() { }

 static items: any[] = []
 static scheduledMessageDetails: SmartSmsRequestRecipientScheduledMessagesDetail[] = []

}